module.exports = __webpack_public_path__ + "static/gallery12-3932d7d9edc4568a9964d7e724d5018c.jpg";